import actionCreator from 'helpers/actionCreator'
import { SET_MULTI_IMAGER, CREATE_MULTI_IMAGER_LENS, ADD_MULTI_IMAGER_LENS, ADD_LENS_IDS,
  COPY_MULTI_IMAGER, DUPLICATE_MULTI_IMAGER_LENS, DESTROY_MULTI_IMAGER, REMOVE_MULTI_IMAGER,
  CLEAR_MULTI_IMAGER_LENSES, UPDATE_FIXED_LENS, UPDATE_ALL_LENSES } from 'actions/multiImagerActionTypes'

/** Called as an action when selecting a multi imager model */
export const setMultiImagerAction = actionCreator(SET_MULTI_IMAGER, 'model', 'aov', 'skipRemove')

/** Called as an action when creating a multi imager lens */
export const createMultiImagerLensAction = actionCreator(CREATE_MULTI_IMAGER_LENS, 'lens')

/** Called as an action when adding a multi imager lens */
export const addMultiImagerLensAction = actionCreator(ADD_MULTI_IMAGER_LENS, 'lens')

/** Called as an action when setting multi imager lens IDs */
export const addLensIdsAction = actionCreator(ADD_LENS_IDS, 'id', 'lensIds', 'fixedLensIds')

/** Called as an action when copying a multi imager */
export const copyMultiImagerAction = actionCreator(COPY_MULTI_IMAGER, 'id')

/** Called as an action when duplicating a multi imager lens */
export const duplicateMultiImagerLensAction = actionCreator(DUPLICATE_MULTI_IMAGER_LENS, 'id', 'location', 'newId', 'imagerId')

/** Called as an action when destroying a multi imager */
export const destroyMultiImagerAction = actionCreator(DESTROY_MULTI_IMAGER, 'id')

/** Called as an action when removing a multi imager */
export const removeMultiImagerAction = actionCreator(REMOVE_MULTI_IMAGER, 'id', 'lensIds', 'idToSwitchTo')

/** Called as an action when clearing a multi imager's lenses */
export const clearMultiImagerLensesAction = actionCreator(CLEAR_MULTI_IMAGER_LENSES, 'id', 'lensIds')

/** Called as an action when updating a fixed lens */
export const updateFixedLensAction = actionCreator(UPDATE_FIXED_LENS, 'value', 'key', 'id', 'fromMap')

/** Called as an action when updating all lenses */
export const updateAllLensesAction = actionCreator(UPDATE_ALL_LENSES, 'value', 'key', 'id', 'fromMap')



// WEBPACK FOOTER //
// ./src/actions/multiImagerActions.js